// extracted by mini-css-extract-plugin
export var textInput = "_ee-0";